import { OnInit } from '@angular/core';
var WarrantyStatusBadgeComponent = /** @class */ (function () {
    function WarrantyStatusBadgeComponent() {
    }
    WarrantyStatusBadgeComponent.prototype.ngOnInit = function () {
        this.textColor = this.getTextColor(this.status);
        this.backgroundColor = this.getBackgroundColor(this.status);
    };
    WarrantyStatusBadgeComponent.prototype.getTextColor = function (status) {
        switch (status) {
            case 'active':
                return '#29A37A';
            case 'expired':
                return '#FF0000';
            case 'extended':
                return '#FFAA00';
            case 'future':
                return '#00AAFF';
            default:
                return null;
        }
    };
    WarrantyStatusBadgeComponent.prototype.getBackgroundColor = function (status) {
        switch (status) {
            case 'active':
                return '#2fb6881a';
            case 'expired':
                return '#ff00001a';
            case 'extended':
                return '#ffaa001a';
            case 'future':
                return '#00aaff1a';
            default:
                return null;
        }
    };
    return WarrantyStatusBadgeComponent;
}());
export { WarrantyStatusBadgeComponent };
